import Modal from "react-bootstrap/Modal";
import "./style.css";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import Select from "react-select";
import { apiEditGodown, apiListBranch } from "../../../api/master";
import godownSchema from "../../../validations/Godown";

function GodownEdit(props) {
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const [branch, setBranchValue] = useState([]);
  async function getBranch() {
    await apiListBranch({ paginate: 0, is_active: 1 }).then((result) =>
      setBranchValue(result.data.data.list),
    );
  }

  useEffect(() => {
    getBranch();
  }, []);

  const godownFormik = useFormik({
    initialValues: {
      godown_id: props.id?.godown_id,
      tally_godown_name: props.id?.tally_godown_name,
      godown_address: props.id?.godown_address,
      godown_name: props.id?.godown_name,
      branch_id: props.id?.branch_id || [],
    },
    validationSchema: godownSchema.validateGodownEdit(),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      const payload = {
        godown_id: Number(values.godown_id),
        godown_name: values.godown_name,
        tally_godown_name: values.tally_godown_name,
        godown_address: values.godown_address,
        branch_id: values.branch_id.map(Number),
      };
      setIsSubmit(true);
      await apiEditGodown(payload)
        .then((data) => {
          setSuccess(data.data.message);
          setError("");
          props.list();
        })
        .catch((err) => {
          setError(err.response.data.data.message);
          setSuccess("");
        })
        .finally(() => {
          setIsSubmit(false);
          setTimeout(() => {
            setSuccess("");
            setError("");
          }, 5000);
        });
    },
  });

  const branchOptions = branch.map((list) => ({
    value: list.branch_id,
    label: list.branch_name,
  }));

  const selectedBranches = branchOptions.filter((option) =>
    godownFormik.values.branch_id.includes(option.value),
  );

  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "10rem", height: "4px" }} id="modalhead">
          Edit Godown
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <form
          className="row gx-5 gy-2"
          onSubmit={godownFormik.handleSubmit}
          autoComplete="off"
        >
          <div className="col-md-6">
            <label htmlFor="godown_name">
              Godown Name <span className="text-danger">*</span>
            </label>
            <input
              maxLength={45}
              type="text"
              className="form-control"
              id="godown_name"
              {...godownFormik.getFieldProps("godown_name")}
            />
            {godownFormik.errors.godown_name ? (
              <div className="text-danger small">
                {godownFormik.errors.godown_name}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="tally_godown_name">
              Tally Godown Name <span className="text-danger">*</span>
            </label>
            <input
              maxLength={45}
              type="text"
              className="form-control"
              id="tally_godown_name"
              {...godownFormik.getFieldProps("tally_godown_name")}
            />
            {godownFormik.errors.tally_godown_name ? (
              <div className="text-danger small">
                {godownFormik.errors.tally_godown_name}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="godown_address">Godown Address</label>
            <input
              type="text"
              maxLength={100}
              className="form-control"
              id="godown_address"
              {...godownFormik.getFieldProps("godown_address")}
            />
            {godownFormik.errors.godown_address ? (
              <div className="text-danger small">
                {godownFormik.errors.godown_address}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="branch_id">
              Branch <span className="text-danger">*</span>
            </label>
            <Select
              isMulti
              options={branchOptions}
              value={selectedBranches}
              onChange={(selectedOptions) => {
                const branchIds = selectedOptions.map((option) => option.value);
                godownFormik.setFieldValue("branch_id", branchIds);
              }}
              classNamePrefix="react-select"
            />
            {godownFormik.errors.branch_id ? (
              <div className="text-danger small">
                {godownFormik.errors.branch_id}
              </div>
            ) : null}
          </div>
          <div className="col-12 mt-4">
            {(error || success) && (
              <div
                className={`alert alert-${
                  error ? "danger" : "success"
                } py-2 small`}
                role="alert"
              >
                {error || success || ""}
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "end",
              }}
            >
              <button
                className="branchModalCancel"
                onClick={props.hide}
                type="button"
                style={{
                  height: "33px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  float: "right",
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmit}
                style={{
                  height: "33px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  float: "right",
                }}
              >
                {isSubmit && (
                  <span className="spinner-border spinner-border-sm me-2"></span>
                )}
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default GodownEdit;
